import React from 'react';

const TermsOfService = ({ onBack }) => {
  return (
    <div className="min-h-screen py-10 px-4" style={{ backgroundColor: 'var(--bg-base)' }}>
      <div className="max-w-3xl mx-auto">
        {/* Back button */}
        <button
          onClick={onBack}
          className="mb-6 flex items-center gap-2 text-sm font-medium transition-colors"
          style={{ color: 'var(--accent-primary)' }}
        >
          <span>←</span> Back
        </button>

        <div className="p-8 rounded-2xl" style={{ backgroundColor: 'var(--card-bg)', border: '1px solid var(--card-border)' }}>
          <h1 className="text-3xl font-bold mb-2" style={{ color: 'var(--text-primary)' }}>Terms of Use and Service Agreement</h1>
          <p className="text-sm mb-1" style={{ color: 'var(--text-muted)' }}>Effective Date: February 25, 2026</p>
          <p className="text-sm mb-8" style={{ color: 'var(--text-muted)' }}>Last Updated: February 25, 2026</p>

          <div className="space-y-6 text-sm leading-relaxed" style={{ color: 'var(--text-secondary)' }}>

            {/* 1 */}
            <section>
              <h2 className="text-lg font-semibold mb-2" style={{ color: 'var(--text-primary)' }}>1. Acceptance of Terms</h2>
              <p>
                By accessing, downloading, or using this Platform (hereinafter "Service"), you ("User," "you," or "your") agree to be
                bound by these Terms of Use ("Agreement"). If you do not agree to these terms, you must immediately cease use of the
                Service. Your continued use constitutes acceptance.
              </p>
            </section>

            {/* 2 */}
            <section>
              <h2 className="text-lg font-semibold mb-2" style={{ color: 'var(--text-primary)' }}>2. Eligibility and Account Registration</h2>
              <h3 className="font-semibold mt-3 mb-1" style={{ color: 'var(--text-primary)' }}>2.1 Age and Capacity</h3>
              <p>
                You must be at least eighteen (18) years of age or the age of majority in your jurisdiction, whichever is greater.
                You represent that you have the legal capacity to enter into binding agreements and are not prohibited from using this
                Service under applicable law.
              </p>
              <h3 className="font-semibold mt-3 mb-1" style={{ color: 'var(--text-primary)' }}>2.2 Account Information</h3>
              <p>
                You agree to provide accurate, current, and complete information during registration and maintain this accuracy. You are
                solely responsible for maintaining the confidentiality of your account credentials and all activities occurring under
                your account. You agree to notify us immediately of any unauthorized access or misuse.
              </p>
              <h3 className="font-semibold mt-3 mb-1" style={{ color: 'var(--text-primary)' }}>2.3 Account Termination</h3>
              <p>We reserve the right to suspend, restrict, or terminate your account if:</p>
              <ul className="list-disc pl-5 space-y-1 mt-1">
                <li>You provide false or misleading information</li>
                <li>You violate these Terms or any applicable law</li>
                <li>We determine your account poses a risk to other users or the Service</li>
                <li>You engage in prohibited conduct as outlined herein</li>
              </ul>
            </section>

            {/* 3 */}
            <section>
              <h2 className="text-lg font-semibold mb-2" style={{ color: 'var(--text-primary)' }}>3. Prohibited Conduct and User Responsibilities</h2>
              <h3 className="font-semibold mt-3 mb-1" style={{ color: 'var(--text-primary)' }}>3.1 Prohibited Activities</h3>
              <p className="mb-1">You agree not to:</p>
              <ul className="list-[lower-alpha] pl-5 space-y-1">
                <li>Upload, post, transmit, or share content that is illegal, defamatory, obscene, threatening, harassing, or violates intellectual property, privacy, or publicity rights;</li>
                <li>Engage in harassment, bullying, discrimination, or hate speech based on protected characteristics;</li>
                <li>Transmit viruses, malware, or any code designed to disrupt or damage the Service;</li>
                <li>Attempt to gain unauthorized access to the Service, its systems, or other users' accounts;</li>
                <li>Engage in phishing, fraud, or deception;</li>
                <li>Spam, flood, or post repetitive or irrelevant content;</li>
                <li>Impersonate any person or entity;</li>
                <li>Engage in any activity that violates applicable law in any jurisdiction where you reside or from which you access the Service;</li>
                <li>Scrape, crawl, or use automated systems to extract data from the Service without authorization;</li>
                <li>Interfere with the functionality, operation, or integrity of the Service.</li>
              </ul>
              <h3 className="font-semibold mt-3 mb-1" style={{ color: 'var(--text-primary)' }}>3.2 User Responsibility</h3>
              <p>You are solely responsible for all content you create, post, or share. You warrant that:</p>
              <ul className="list-disc pl-5 space-y-1 mt-1">
                <li>You own or have permission to use all content you upload</li>
                <li>Your content does not infringe on third-party rights</li>
                <li>You have obtained all necessary consents for any personal data of others contained in your content</li>
              </ul>
            </section>

            {/* 4 */}
            <section>
              <h2 className="text-lg font-semibold mb-2" style={{ color: 'var(--text-primary)' }}>4. Intellectual Property Rights</h2>
              <h3 className="font-semibold mt-3 mb-1" style={{ color: 'var(--text-primary)' }}>4.1 Platform Ownership</h3>
              <p>
                The Service, including its design, functionality, code, and documentation, is the exclusive property of the Platform
                or its licensors. No license or ownership is transferred to you.
              </p>
              <h3 className="font-semibold mt-3 mb-1" style={{ color: 'var(--text-primary)' }}>4.2 User-Generated Content Ownership and License</h3>
              <p>
                You retain all ownership rights to content you create and post ("User Content"). By posting User Content, you grant
                the Platform a non-exclusive, royalty-free, worldwide, perpetual license to:
              </p>
              <ul className="list-disc pl-5 space-y-1 mt-1">
                <li>Display, distribute, and host your User Content within the Service</li>
                <li>Create derivative works or modifications for operational and promotional purposes</li>
                <li>Use your content to improve the Service's functionality and user experience</li>
              </ul>
              <p className="mt-2">
                This license does not permit us to sell your content or use it outside the Platform without separate written agreement.
              </p>
              <h3 className="font-semibold mt-3 mb-1" style={{ color: 'var(--text-primary)' }}>4.3 Copyright and Intellectual Property Compliance</h3>
              <p>
                If you believe your intellectual property rights have been infringed, contact us immediately with documentation. We
                will investigate and take appropriate action, which may include content removal and account suspension.
              </p>
            </section>

            {/* 5 */}
            <section>
              <h2 className="text-lg font-semibold mb-2" style={{ color: 'var(--text-primary)' }}>5. Community Events: User-Created Events</h2>
              <h3 className="font-semibold mt-3 mb-1" style={{ color: 'var(--text-primary)' }}>5.1 Event Creation Responsibility</h3>
              <p>
                The Platform provides tools for users to create, organize, and promote events ("Events"). Event organizers
                ("Organizers") are solely responsible for:
              </p>
              <ul className="list-[lower-alpha] pl-5 space-y-1 mt-1">
                <li>Planning, coordinating, and executing Events;</li>
                <li>Ensuring compliance with all applicable laws and regulations governing event organization, safety, and liability in their jurisdiction;</li>
                <li>Obtaining all necessary permits, licenses, and insurance;</li>
                <li>Verifying venue availability, safety, accessibility, and compliance with local regulations;</li>
                <li>Communicating clearly with participants about event details, changes, cancellations, or postponements;</li>
                <li>Managing participant conduct and behavior;</li>
                <li>Addressing disputes, complaints, or issues arising from the Event.</li>
              </ul>
              <h3 className="font-semibold mt-3 mb-1" style={{ color: 'var(--text-primary)' }}>5.2 Platform Facilitation Only</h3>
              <p>The Platform acts solely as a neutral communication and organizational tool. We do not:</p>
              <ul className="list-disc pl-5 space-y-1 mt-1">
                <li>Organize, sponsor, or endorse any Events</li>
                <li>Verify the authenticity, legality, or safety of Events</li>
                <li>Assume responsibility for event execution or participant experience</li>
                <li>Guarantee the accuracy of Event information provided by Organizers</li>
                <li>Monitor or supervise Events</li>
              </ul>
              <h3 className="font-semibold mt-3 mb-1" style={{ color: 'var(--text-primary)' }}>5.3 Participant Responsibility</h3>
              <p>Participants acknowledge that they:</p>
              <ul className="list-disc pl-5 space-y-1 mt-1">
                <li>Participate at their own risk</li>
                <li>Are responsible for verifying Event details independently</li>
                <li>Assume all risks associated with attending or participating in Events</li>
                <li>Are responsible for their own safety, health, and conduct</li>
              </ul>
              <h3 className="font-semibold mt-3 mb-1" style={{ color: 'var(--text-primary)' }}>5.4 Prohibited Events</h3>
              <p>Organizers must not create Events that:</p>
              <ul className="list-disc pl-5 space-y-1 mt-1">
                <li>Violate applicable law</li>
                <li>Involve illegal activities or services</li>
                <li>Endanger participant safety or public health</li>
                <li>Infringe on third-party rights</li>
                <li>Deceive or defraud participants</li>
                <li>Involve discrimination or harassment</li>
              </ul>
            </section>

            {/* 6 */}
            <section>
              <h2 className="text-lg font-semibold mb-2" style={{ color: 'var(--text-primary)' }}>6. Limitation of Liability</h2>
              <h3 className="font-semibold mt-3 mb-1" style={{ color: 'var(--text-primary)' }}>6.1 No Warranty for User Content and Events</h3>
              <p>
                The Platform provides the Service "as-is" and "as-available" without warranties of any kind. We do not warrant that:
              </p>
              <ul className="list-disc pl-5 space-y-1 mt-1">
                <li>User Content or Event information is accurate, complete, or lawful</li>
                <li>Events will occur as described or will be free from disruption</li>
                <li>The Service will be uninterrupted, error-free, or secure</li>
                <li>All content is appropriate or non-harmful</li>
              </ul>
              <h3 className="font-semibold mt-3 mb-1" style={{ color: 'var(--text-primary)' }}>6.2 Disclaimers</h3>
              <p>To the maximum extent permitted by law, we disclaim:</p>
              <ul className="list-disc pl-5 space-y-1 mt-1">
                <li>All implied warranties, including merchantability, fitness for a particular purpose, and non-infringement</li>
                <li>Responsibility for any injuries, losses, or damages arising from Events</li>
                <li>Liability for third-party conduct, including organizers, participants, venue operators, and service providers</li>
                <li>Any indirect, incidental, special, consequential, or punitive damages</li>
              </ul>
              <h3 className="font-semibold mt-3 mb-1" style={{ color: 'var(--text-primary)' }}>6.3 User Assumption of Risk</h3>
              <p>By using the Service, you assume all risks associated with:</p>
              <ul className="list-disc pl-5 space-y-1 mt-1">
                <li>Event participation and attendance</li>
                <li>User Content and interactions with other users</li>
                <li>Technical issues or service interruptions</li>
                <li>Third-party conduct</li>
              </ul>
            </section>

            {/* 7 */}
            <section>
              <h2 className="text-lg font-semibold mb-2" style={{ color: 'var(--text-primary)' }}>7. Indemnification</h2>
              <h3 className="font-semibold mt-3 mb-1" style={{ color: 'var(--text-primary)' }}>7.1 User Indemnity</h3>
              <p>
                To the maximum extent permitted by law, you agree to indemnify, defend, and hold harmless the Platform, its affiliates,
                officers, directors, employees, and agents from any claims, damages, losses, costs, or liabilities (including legal fees)
                arising from:
              </p>
              <ul className="list-[lower-alpha] pl-5 space-y-1 mt-1">
                <li>Your violation of these Terms or applicable law;</li>
                <li>Your User Content or misuse of the Service;</li>
                <li>Your participation in or organization of Events;</li>
                <li>Your violation of third-party rights;</li>
                <li>Disputes between you and other users or third parties;</li>
                <li>Claims by attendees, participants, or venue operators related to your Events;</li>
                <li>Negligence, intentional misconduct, or fraud by you.</li>
              </ul>
              <p className="mt-2">
                This indemnification obligation applies even if the Platform was negligent in investigating or addressing violations.
              </p>
              <h3 className="font-semibold mt-3 mb-1" style={{ color: 'var(--text-primary)' }}>7.2 Event-Related Claims</h3>
              <p>
                Organizers indemnify the Platform against all claims arising from their Events, including but not limited to personal
                injury, property damage, contract disputes, liability claims, or regulatory violations, regardless of whether such
                claims are foreseeable or preventable.
              </p>
            </section>

            {/* 8 */}
            <section>
              <h2 className="text-lg font-semibold mb-2" style={{ color: 'var(--text-primary)' }}>8. Privacy and Data Protection</h2>
              <h3 className="font-semibold mt-3 mb-1" style={{ color: 'var(--text-primary)' }}>8.1 Personal Data Collection</h3>
              <p>
                We collect and process personal data as described in our Privacy Policy. By using the Service, you consent to such
                collection and processing in accordance with applicable data protection laws.
              </p>
              <h3 className="font-semibold mt-3 mb-1" style={{ color: 'var(--text-primary)' }}>8.2 Data Security</h3>
              <p>
                While we implement reasonable security measures, no system is completely secure. We cannot guarantee the absolute
                security of your data. You are responsible for protecting your account credentials.
              </p>
              <h3 className="font-semibold mt-3 mb-1" style={{ color: 'var(--text-primary)' }}>8.3 User Rights</h3>
              <p>Depending on your jurisdiction, you may have rights to:</p>
              <ul className="list-disc pl-5 space-y-1 mt-1">
                <li>Access your personal data</li>
                <li>Request correction of inaccurate data</li>
                <li>Request deletion of your data</li>
                <li>Opt-out of certain data processing</li>
                <li>Obtain a portable copy of your data</li>
              </ul>
              <p className="mt-2">To exercise these rights, contact us as outlined in the "Contact Information" section.</p>
              <h3 className="font-semibold mt-3 mb-1" style={{ color: 'var(--text-primary)' }}>8.4 Cross-Border Data Transfers</h3>
              <p>
                Your data may be transferred to, stored in, or processed in jurisdictions other than where you reside. By using the
                Service, you consent to such transfers subject to appropriate safeguards.
              </p>
            </section>

            {/* 9 */}
            <section>
              <h2 className="text-lg font-semibold mb-2" style={{ color: 'var(--text-primary)' }}>9. Content Moderation and Removal</h2>
              <h3 className="font-semibold mt-3 mb-1" style={{ color: 'var(--text-primary)' }}>9.1 Right to Moderate Content</h3>
              <p>We reserve the right to, but are not obligated to:</p>
              <ul className="list-disc pl-5 space-y-1 mt-1">
                <li>Review, monitor, or filter User Content</li>
                <li>Remove content that violates these Terms or applicable law</li>
                <li>Restrict or block access to certain content</li>
                <li>Suspend or terminate accounts engaging in prohibited conduct</li>
                <li>Issue warnings or escalate violations</li>
              </ul>
              <h3 className="font-semibold mt-3 mb-1" style={{ color: 'var(--text-primary)' }}>9.2 User Reporting</h3>
              <p>
                You may report violations or inappropriate content through our reporting system. We will review reports and take
                action within a reasonable timeframe. However, we cannot guarantee removal of all reported content or immediate action.
              </p>
              <h3 className="font-semibold mt-3 mb-1" style={{ color: 'var(--text-primary)' }}>9.3 No Obligation to Monitor</h3>
              <p>
                The Platform is not obligated to continuously monitor User Content or Events. We act as a neutral intermediary and
                are not responsible for content created by users.
              </p>
            </section>

            {/* 10 */}
            <section>
              <h2 className="text-lg font-semibold mb-2" style={{ color: 'var(--text-primary)' }}>10. Disclaimer of Platform Liability for Third Parties</h2>
              <h3 className="font-semibold mt-3 mb-1" style={{ color: 'var(--text-primary)' }}>10.1 Third-Party Conduct</h3>
              <p>The Platform is not responsible for the conduct, actions, omissions, representations, warranties, or products/services of:</p>
              <ul className="list-disc pl-5 space-y-1 mt-1">
                <li>Event Organizers</li>
                <li>Event Participants</li>
                <li>Venue Operators</li>
                <li>Service Providers</li>
                <li>Third-Party Advertisers</li>
                <li>Other Users</li>
              </ul>
              <h3 className="font-semibold mt-3 mb-1" style={{ color: 'var(--text-primary)' }}>10.2 Event Disclaimers</h3>
              <p>The Platform assumes no liability for:</p>
              <ul className="list-disc pl-5 space-y-1 mt-1">
                <li>Event cancellations, postponements, or modifications</li>
                <li>Inadequate event facilities, safety measures, or insurance</li>
                <li>Injuries, illnesses, or deaths occurring at or related to Events</li>
                <li>Property damage or loss</li>
                <li>Contract breaches between Organizers and Participants</li>
                <li>Discrimination or misconduct by event participants</li>
                <li>Regulatory violations or unlawful activities at Events</li>
              </ul>
              <h3 className="font-semibold mt-3 mb-1" style={{ color: 'var(--text-primary)' }}>10.3 Medical and Emergency Matters</h3>
              <p>
                The Platform does not provide medical advice or emergency services. Users experiencing medical emergencies should
                contact local emergency services. Events must comply with all health and safety regulations.
              </p>
            </section>

            {/* 11 */}
            <section>
              <h2 className="text-lg font-semibold mb-2" style={{ color: 'var(--text-primary)' }}>11. Limitation of Liability Cap</h2>
              <p>
                To the maximum extent permitted by law, in no event shall the Platform's total liability to you exceed the Fees paid
                by you in the one (1) month preceding the claim.
              </p>
              <p className="mt-2">
                This cap applies to all claims, whether in contract, tort, strict liability, or otherwise, and notwithstanding any
                failure of essential purpose of any limited remedy.
              </p>
            </section>

            {/* 12 */}
            <section>
              <h2 className="text-lg font-semibold mb-2" style={{ color: 'var(--text-primary)' }}>12. Modifications to Terms and Service</h2>
              <h3 className="font-semibold mt-3 mb-1" style={{ color: 'var(--text-primary)' }}>12.1 Amendment Rights</h3>
              <p>We reserve the right to modify these Terms at any time. Material changes will be communicated via:</p>
              <ul className="list-disc pl-5 space-y-1 mt-1">
                <li>Email notification to your registered account</li>
                <li>Prominent notice on the Platform</li>
                <li>Updated terms posted on our website</li>
              </ul>
              <h3 className="font-semibold mt-3 mb-1" style={{ color: 'var(--text-primary)' }}>12.2 Acceptance of Changes</h3>
              <p>
                Your continued use of the Service following notification constitutes acceptance of modified terms. If you do not
                agree with changes, you must cease using the Service.
              </p>
              <h3 className="font-semibold mt-3 mb-1" style={{ color: 'var(--text-primary)' }}>12.3 Service Modifications</h3>
              <p>
                We may modify, suspend, or discontinue the Service (or any feature) at any time with or without notice. We are not
                liable for such modifications or discontinuation.
              </p>
            </section>

            {/* 13 */}
            <section>
              <h2 className="text-lg font-semibold mb-2" style={{ color: 'var(--text-primary)' }}>13. Termination</h2>
              <h3 className="font-semibold mt-3 mb-1" style={{ color: 'var(--text-primary)' }}>13.1 Termination by User</h3>
              <p>
                You may terminate your account at any time by submitting a termination request through your account settings or
                contacting support.
              </p>
              <h3 className="font-semibold mt-3 mb-1" style={{ color: 'var(--text-primary)' }}>13.2 Termination by Platform</h3>
              <p>We may terminate or suspend your account immediately, without notice or cause, if:</p>
              <ul className="list-disc pl-5 space-y-1 mt-1">
                <li>We determine it is necessary to protect user safety or platform integrity</li>
                <li>You violate these Terms or applicable law</li>
                <li>We cease operating the Service</li>
              </ul>
              <h3 className="font-semibold mt-3 mb-1" style={{ color: 'var(--text-primary)' }}>13.3 Post-Termination</h3>
              <p>Upon termination:</p>
              <ul className="list-disc pl-5 space-y-1 mt-1">
                <li>Your access to the Service ceases immediately</li>
                <li>You remain liable for any outstanding obligations</li>
                <li>Your User Content may be retained and used subject to the rights granted herein</li>
                <li>Certain provisions survive termination indefinitely</li>
              </ul>
            </section>

            {/* 14 */}
            <section>
              <h2 className="text-lg font-semibold mb-2" style={{ color: 'var(--text-primary)' }}>14. Severability</h2>
              <p>
                If any provision of these Terms is found to be invalid, unlawful, or unenforceable, such provision shall be modified
                to the minimum extent necessary to render it valid, or if impossible, severed. The remaining provisions continue in
                full force and effect.
              </p>
            </section>

            {/* 15 */}
            <section>
              <h2 className="text-lg font-semibold mb-2" style={{ color: 'var(--text-primary)' }}>15. Governing Law and Dispute Resolution</h2>
              <h3 className="font-semibold mt-3 mb-1" style={{ color: 'var(--text-primary)' }}>15.1 Governing Law</h3>
              <p>
                These Terms are governed by the laws of the jurisdiction in which the Platform is established, without regard to
                conflicts of law principles.
              </p>
              <h3 className="font-semibold mt-3 mb-1" style={{ color: 'var(--text-primary)' }}>15.2 Dispute Resolution</h3>
              <p>Before initiating formal legal proceedings, parties agree to attempt resolution through good-faith negotiation. If unresolved, disputes may be submitted to:</p>
              <ul className="list-disc pl-5 space-y-1 mt-1">
                <li>Mediation by a neutral third party</li>
                <li>Arbitration (if applicable under your jurisdiction's law)</li>
                <li>Court litigation as a final resort</li>
              </ul>
              <h3 className="font-semibold mt-3 mb-1" style={{ color: 'var(--text-primary)' }}>15.3 Waiver of Class Action</h3>
              <p>
                To the maximum extent permitted by law, you waive any right to bring claims on a class-wide, consolidated, or
                representative basis.
              </p>
            </section>

            {/* 16 */}
            <section>
              <h2 className="text-lg font-semibold mb-2" style={{ color: 'var(--text-primary)' }}>16. Compliance with Applicable Law</h2>
              <h3 className="font-semibold mt-3 mb-1" style={{ color: 'var(--text-primary)' }}>16.1 Legal Obligations</h3>
              <p>We comply with applicable legal obligations in jurisdictions where we operate, including but not limited to:</p>
              <ul className="list-disc pl-5 space-y-1 mt-1">
                <li>Transparency and disclosure requirements</li>
                <li>User rights and protections</li>
                <li>Content removal procedures and notification mechanisms</li>
                <li>Appeal and recourse processes for account actions</li>
                <li>Data protection and privacy safeguards</li>
              </ul>
              <h3 className="font-semibold mt-3 mb-1" style={{ color: 'var(--text-primary)' }}>16.2 Regulatory Cooperation</h3>
              <p>
                We cooperate with law enforcement and regulatory authorities regarding illegal activities. You waive any expectation
                of confidentiality regarding information disclosed to authorities.
              </p>
            </section>

            {/* 17 */}
            <section>
              <h2 className="text-lg font-semibold mb-2" style={{ color: 'var(--text-primary)' }}>17. Export Controls</h2>
              <p>
                You agree not to export, re-export, or transfer the Service or technical data in violation of applicable export
                control laws. This includes use by restricted persons or organizations.
              </p>
            </section>

            {/* 18 */}
            <section>
              <h2 className="text-lg font-semibold mb-2" style={{ color: 'var(--text-primary)' }}>18. Entire Agreement</h2>
              <p>
                These Terms, together with our Privacy Policy and any other policies referenced herein, constitute the entire
                agreement between you and the Platform regarding the Service. They supersede all prior or contemporaneous
                agreements, understandings, or negotiations.
              </p>
            </section>

            {/* 19 */}
            <section>
              <h2 className="text-lg font-semibold mb-2" style={{ color: 'var(--text-primary)' }}>19. Contact Information</h2>
              <p>For questions, support, or to exercise data rights, contact:</p>
              <p className="mt-2">
                <strong style={{ color: 'var(--text-primary)' }}>Email:</strong>{' '}
                <a href="mailto:foundersplus2025@gmail.com" style={{ color: 'var(--accent-primary)' }}>
                  foundersplus2025@gmail.com
                </a>
              </p>
              <p className="mt-1">
                <strong style={{ color: 'var(--text-primary)' }}>Response Time:</strong> We respond to inquiries within fifteen (15) business days.
              </p>
            </section>

            {/* Schedule A */}
            <section>
              <h2 className="text-lg font-semibold mb-2" style={{ color: 'var(--text-primary)' }}>Schedule A: Special Provisions for Events</h2>
              <h3 className="font-semibold mt-3 mb-1" style={{ color: 'var(--text-primary)' }}>A.1 Event Organizer Acknowledgments</h3>
              <p>Event Organizers explicitly acknowledge and agree:</p>
              <ul className="list-[lower-alpha] pl-5 space-y-1 mt-1">
                <li>They are solely responsible for all aspects of their Events;</li>
                <li>They assume all liability for participant safety, injuries, and damages;</li>
                <li>They maintain appropriate insurance coverage;</li>
                <li>They comply with all local, regional, and national laws governing event organization;</li>
                <li>They shall not mislead, defraud, or deceive participants;</li>
                <li>The Platform makes no representations regarding Event quality, execution, or safety;</li>
                <li>The Platform is not party to any contracts between Organizers and Participants;</li>
                <li>They indemnify the Platform against all Event-related claims.</li>
              </ul>
              <h3 className="font-semibold mt-3 mb-1" style={{ color: 'var(--text-primary)' }}>A.2 Participant Acknowledgments</h3>
              <p>Event Participants explicitly acknowledge:</p>
              <ul className="list-[lower-alpha] pl-5 space-y-1 mt-1">
                <li>They participate entirely at their own risk;</li>
                <li>They assume all responsibility for their safety and conduct;</li>
                <li>They verify Event details independently before attending;</li>
                <li>The Platform does not endorse or guarantee Event information;</li>
                <li>They shall comply with Organizer instructions and venue rules;</li>
                <li>They waive claims against the Platform for any Event-related injuries or damages.</li>
              </ul>
              <h3 className="font-semibold mt-3 mb-1" style={{ color: 'var(--text-primary)' }}>A.3 Event Cancellation and Force Majeure</h3>
              <p>
                The Platform is not liable for Event cancellations caused by unforeseen circumstances, including natural disasters,
                pandemics, war, acts of terrorism, or government action. Organizers are responsible for communicating cancellations
                and managing participant communications.
              </p>
            </section>

            {/* Acknowledgment */}
            <section className="mt-8 p-4 rounded-xl" style={{ backgroundColor: 'var(--bg-elevated)', border: '1px solid var(--card-border)' }}>
              <p className="font-medium" style={{ color: 'var(--text-primary)' }}>Acknowledgment</p>
              <p className="mt-2">
                By clicking "I Agree," registering an account, or using the Service, you certify that you have read, understood,
                and agree to be bound by these Terms of Use in their entirety.
              </p>
              <p className="mt-2 font-medium" style={{ color: 'var(--text-primary)' }}>If you do not agree, do not use this Service.</p>
            </section>

          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
